if ( typeof ToggleButton !== 'function' ) {

    class ToggleButton extends HTMLElement {

        constructor(){

            super();

            this.addEventListener('click',this.onClickHandler.bind(this));
            this.addEventListener('keydown', e=>{
                if ( e.keyCode == window.KEYCODES.RETURN ) {
                    this.onClickHandler();
                }
            });
        }

        onClickHandler() {
            const parent = this.closest('.tabbed-component-toggles');
            const activeButton = this.classList.contains('active');

            parent.querySelectorAll('toggle-button').forEach(button => {
                button.classList.remove('active', 'button--outline');
                button.classList.add('button--solid');
            });

            parent.querySelector('faq-search input').value = "";

            if (activeButton) {
                parent.querySelectorAll('.toggle--faq').forEach(faq => {
                    faq.style.display = 'block';
                });
            }
            else {
                 this.classList.remove('button--solid');
                 this.classList.add('active', 'button--outline');
                if (this.classList.contains('popular-button')) {
                    parent.querySelectorAll('.toggle--faq').forEach(faq => {
                        faq.style.display = 'none';
                        if (faq.getAttribute('popular') === 'true') {
                            faq.style.display = 'block';
                        }
                    });
                }
                else {
                    parent.querySelectorAll('.toggle--faq').forEach(faq => {
                        faq.style.display = 'none';
                        const tabs = faq.getAttribute('tabs').split(',');
                        if (tabs.includes(this.getAttribute('toggle-target'))) {
                            faq.style.display = 'block';
                        }
                    });
                }
            }
        }
    }
  
    if ( typeof customElements.get('toggle-button') == 'undefined' ) {
        customElements.define('toggle-button', ToggleButton);
    }

}

if ( typeof FaqSearch !== 'function' ) {

    class FaqSearch extends HTMLElement {

        constructor(){

            super();

            this.querySelector('.faq-search-button').addEventListener('click',this.onClickHandler.bind(this));
            this.querySelector('.faq-search-button').addEventListener('keydown', e=>{
                if ( e.keyCode == window.KEYCODES.RETURN ) {
                    this.onClickHandler();
                }
            });
            this.querySelector('input').addEventListener('keydown', e=>{
                if ( e.keyCode == window.KEYCODES.RETURN ) {
                    this.onClickHandler();
                }
            });
            this.querySelector('.clear-button').addEventListener('click',this.onClearHandler.bind(this));
        }

        onClickHandler() {
            const query = this.querySelector('input').value.trim().toLowerCase();
            const parent = this.closest('.tabbed-component-toggles');

            parent.querySelectorAll('toggle-button').forEach(button => {
                button.classList.remove('active');
            });

            parent.querySelectorAll('.toggle--faq').forEach(faq => {
                faq.style.display = 'none';

                const title = faq.querySelector('.faq-title')?.innerText.toLowerCase();
                const subtitle = faq.querySelector('.faq-subtitle')?.innerText.toLowerCase();
                const body = faq.querySelector('.faq-body')?.innerText.toLowerCase();

                if (query === "") {
                    this.onClearHandler();
                }
                else {
                    if (title?.includes(query) || subtitle?.includes(query) || body?.includes(query)) {
                        faq.style.display = 'block';
                    }
                }
            });
        }

        onClearHandler() {
            this.querySelector('input').value = "";
            const parent = this.closest('.tabbed-component-toggles');

            parent.querySelectorAll('toggle-button').forEach(button => {
                button.classList.remove('active');
            });

            parent.querySelectorAll('.toggle--faq').forEach(faq => {
                faq.style.display = 'block';
            });
        }
    }
    
    if ( typeof customElements.get('faq-search') == 'undefined' ) {
        customElements.define('faq-search', FaqSearch);
    }

}